module.exports = function (cyz) {
  return !!cyz && !!cyz.__CANCEL__;
};